import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';

import ALink from 'components/basic/ALink';
import AuthFormWrapper from 'components/basic/AuthFormWrapper';
import { Modal, useModal } from 'components/complex/Modal';
import RegistrationForm from 'components/complex/forms/RegistrationForm';

import { useAppDispatch } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import logEvent from 'analytics/logEvent';

export const RegistrationModal: React.FC = () => {
  const t = useTranslationAndTypograph();
  const dispatch = useAppDispatch();
  const { modalProps } = useModal({
    type: 'Registration',
    width: '656px',
    title: t(`Create an account to subscribe`),
    onAfterOpen: () => {
      logEvent('Web_Register_Page_Viewed', {
        search: window.location.search || null
      });
    },
    subtitle: (
      <>
        {t('Or')}{' '}
        <ALink
          onClick={(): void => {
            dispatch(openModal({ type: 'Auth' }));
          }}
        >
          {t('log in')}
        </ALink>{' '}
        {t('if you already have one')}
      </>
    ),
  });

  let redirectUrl = '';

  if (typeof window !== 'undefined') {
    redirectUrl = modalProps.redirectUrl || window.location.href;
  }

  return (
    <Modal {...modalProps}>
      <AuthFormWrapper withoutTopPadding>
        <RegistrationForm redirectUrl={redirectUrl} />
      </AuthFormWrapper>
    </Modal>
  );
};
